import { api } from '../lib/api';

export interface TraceOverviewItem {
  label: string;
  value: string;
}

export interface TraceSectionColumn {
  key: string;
  label: string;
}

export interface TraceSectionRow {
  [key: string]: string | number | null;
}

export interface TraceSection {
  title: string;
  columns: TraceSectionColumn[];
  rows: TraceSectionRow[];
  emptyText: string;
}

export interface TraceReport {
  query: string;
  matchedAs: string;
  title: string;
  subtitle: string;
  overview: TraceOverviewItem[];
  upstreamSections: TraceSection[];
  downstreamSections: TraceSection[];
}

export const traceabilityApi = {
  search: (query: string) =>
    api.get<TraceReport>(`/trace/search?q=${encodeURIComponent(query.trim())}`),
};
